import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@common-fe/common-fe';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { CONFIG } from '@/utils';
import { FeatureFlagProvider } from '@/utils/featureFlags';

import './styles/font-families';

import App, { ThemeWrapper } from './modules/core/components';
import MaintenanceWrapper from './modules/user/MaintenanceWrapper';
import { initDataDog } from './utils/config';
import MobileResponsiveWrapper from './MobileResponsiveWrapper';

import './styles/global.scss';
import '@common-fe/common-fe/dist/common-fe.css';

const REACT_APP_DOMAIN_PREFIX =
  // @ts-ignore
  window.REACT_APP_DOMAIN_PREFIX || import.meta.env.REACT_APP_DOMAIN_PREFIX || undefined;
dayjs.extend(relativeTime);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

initDataDog();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleReCaptchaProvider type="v3" siteKey={CONFIG.RECAPTCHA_KEY}>
      <BrowserRouter basename={REACT_APP_DOMAIN_PREFIX}>
        <FeatureFlagProvider>
          <ThemeWrapper>
            <MobileResponsiveWrapper>
              <QueryClientProvider client={queryClient}>
                <MaintenanceWrapper>
                  <App />
                </MaintenanceWrapper>
              </QueryClientProvider>
            </MobileResponsiveWrapper>
          </ThemeWrapper>
        </FeatureFlagProvider>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);
